import { Command } from 'commander'
import { BundleCommand } from './bundle'
import { FormatCommand } from './format'
import { MockCommand } from './mock'
import { ServeCommand } from './serve'
import { ShareCommand } from './share'
import { ValidateCommand } from './validate'
import { VoidCommand } from './void'
import { LintCommand } from '@/domains/document/lint'

const documentCommands = [
  BundleCommand,
  FormatCommand,
  MockCommand,
  ServeCommand,
  ShareCommand,
  ValidateCommand,
  VoidCommand,
  LintCommand,
]

const documentDomain = new Command('document')
documentDomain.description('Manage local openapi file')
documentCommands.forEach((command) => documentDomain.addCommand(command()))
export default documentDomain
